import { useEffect, useState } from 'react';
import seniorApi from '~/apis/senior';

const FALLBACK_TIMEZONE = 'America/New_York';

// The senior's time zone (from their profile): dates/times typed on the web mean this zone, as in the app.
export const useSeniorTimezone = (): string | undefined => {
  const [timezone, setTimezone] = useState<string>();

  useEffect(() => {
    seniorApi
      .getProfile()
      .then((resp) => setTimezone(resp.data.data.timezone ?? FALLBACK_TIMEZONE))
      .catch(() => setTimezone(FALLBACK_TIMEZONE));
  }, []);

  return timezone;
};
